import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
  getCommonLabels,
  addCommonLabels as postCommonLabels,
  updateCommonLabels as putCommonLabels,
  deleteCommonLabels as removeCommonLabels,
  activateDeactivateCommonLabels as activateCommonLabels,
  uploadImages

} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Table Column Names
export const fetchQuestionTypeTableColumnNames = createAsyncThunk("questionType/fetchTableColumnNames", async (questionType, thunkAPI) => {
    try {
      const response = await getHeaders(questionType); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Question Type
export const fetchAllQuestionType = createAsyncThunk("questionType/fetchAll", async (questionType, thunkAPI) => {
    try {
      const response = await getCommonLabels(questionType); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Question Type
export const createQuestionType = createAsyncThunk("questionType/add", async (questionType, thunkAPI) => {  
    try {
        const response = await postCommonLabels(questionType);
        toast.success(t(response.message));
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Question Type
export const updateQuestionType = createAsyncThunk("questionType/update", async (questionType, thunkAPI) => {
    try {
        const response = await putCommonLabels(questionType);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Question Type
export const deleteQuestionType = createAsyncThunk("questionType/delete", async (questionType, thunkAPI) => {
    try {
        const response = await removeCommonLabels(questionType);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Activate Deactivate Question Type
export const activateDeactivateQuestionType = createAsyncThunk("questionType/activateDeactivate", async (questionType, thunkAPI) => {
  try {
    const response = await activateCommonLabels(questionType);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message)
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Upload Question Type Image Icon
export const uploadQTypeImageIcon = createAsyncThunk(
  "questionType/uploadQTypeImageIcon", // Changed action type
  async (imageData, thunkAPI) => {
  try {
    const response = await uploadImages(imageData);
    if (response.IsSuccess) {
      return response.Data; 
    } 
  } catch (error) {
    console.log("error",error);
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});